import { createSlice } from "@reduxjs/toolkit";

export const orderSlice = createSlice({
  name: "order",
  initialState: {
    orders: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    //get All
    getOrderStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getOrderSuccess: (state, action) => {
      state.isFetching = false;
      state.orders = action.payload;
    },
    getOrderFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    updateOrderStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    updateProductSuccess: (state, action) => {
        state.isFetching = false;
        state.orders[
          state.orders.findIndex((item) => item._id === action.payload.id)
        ] = action.payload.order;
      },
      updateProductFailure: (state) => {
        state.isFetching = false;
        state.error = true;
      },
  },
});


export const {
    getOrderStart,
    getOrderSuccess,
    getOrderFailure
} = orderSlice.actions;

export default orderSlice.reducer;